// AUTO GENERATED FILE - DO NOT EDIT

const classNames = {
  'attribute': 'attribute',
  'attributes': 'attributes',
  'auth-actions': 'auth-actions',
  'auth-form': 'auth-form',
  'auth-form-field': 'auth-form-field',
  'auth-form-input': 'auth-form-input',
  'auth-form-label': 'auth-form-label',
  'auth-options': 'auth-options',
  'auth-view': 'auth-view',
  'auth-view-main': 'auth-view-main',
  'button': 'button',
  'button-disabled': 'button-disabled',
  'button-hover': 'button-hover',
  'button-hover-bottom': 'button-hover-bottom',
  'button-hover-icon': 'button-hover-icon',
  'button-hover-left': 'button-hover-left',
  'button-hover-right': 'button-hover-right',
  'button-hover-top': 'button-hover-top',
  'button-hover-url': 'button-hover-url',
  'button-icon': 'button-icon',
  'button-icon-container': 'button-icon-container',
  'button-title': 'button-title',
  'cancelled': 'cancelled',
  'cart-value': 'cart-value',
  'cart-value-container': 'cart-value-container',
  'cart-value-qty': 'cart-value-qty',
  'clickable': 'clickable',
  'completed': 'completed',
  'content-frame': 'content-frame',
  'content-full-frame': 'content-full-frame',
  'dark': 'dark',
  'delivery-card': 'delivery-card',
  'delivery-card-actions': 'delivery-card-actions',
  'delivery-card-content': 'delivery-card-content',
  'delivery-card-name': 'delivery-card-name',
  'delivery-card-status': 'delivery-card-status',
  'delivery-card-status-icon': 'delivery-card-status-icon',
  'delivery-view': 'delivery-view',
  'delivery-view-actions': 'delivery-view-actions',
  'delivery-view-container': 'delivery-view-container',
  'delivery-view-content': 'delivery-view-content',
  'delivery-view-embedded': 'delivery-view-embedded',
  'delivery-view-filler': 'delivery-view-filler',
  'delivery-view-heading': 'delivery-view-heading',
  'delivery-view-status': 'delivery-view-status',
  'delivery-view-status-container': 'delivery-view-status-container',
  'delivery-view-subheading': 'delivery-view-subheading',
  'delivery-view-trip': 'delivery-view-trip',
  'delivery-view-trip-coords': 'delivery-view-trip-coords',
  'delivery-view-trip-icon': 'delivery-view-trip-icon',
  'delivery-view-trip-location': 'delivery-view-trip-location',
  'delivery-view-trip-text': 'delivery-view-trip-text',
  'delivery-view-trips': 'delivery-view-trips',
  'error-code': 'error-code',
  'error-container': 'error-container',
  'error-content': 'error-content',
  'error-heading': 'error-heading',
  'error-image': 'error-image',
  'error-message': 'error-message',
  'error-meta': 'error-meta',
  'footer': 'footer',
  'footer-content': 'footer-content',
  'heading-large': 'heading-large',
  'heading-max': 'heading-max',
  'heading-medium': 'heading-medium',
  'heading-small': 'heading-small',
  'history-page': 'history-page',
  'history-view': 'history-view',
  'history-view-content': 'history-view-content',
  'history-view-filler': 'history-view-filler',
  'history-view-footer': 'history-view-footer',
  'history-view-header': 'history-view-header',
  'history-view-header-icon': 'history-view-header-icon',
  'history-view-loading': 'history-view-loading',
  'history-view-loading-spinner': 'history-view-loading-spinner',
  'home-view': 'home-view',
  'home-view-body': 'home-view-body',
  'home-view-content': 'home-view-content',
  'home-view-logo': 'home-view-logo',
  'in-progress': 'in-progress',
  'input': 'input',
  'input-container': 'input-container',
  'large-card': 'large-card',
  'large-card-content': 'large-card-content',
  'large-card-image': 'large-card-image',
  'large-card-image-container': 'large-card-image-container',
  'large-card-link': 'large-card-link',
  'large-card-meta': 'large-card-meta',
  'large-card-price': 'large-card-price',
  'large-card-title': 'large-card-title',
  'limit-width': 'limit-width',
  'line-break': 'line-break',
  'link-button': 'link-button',
  'loading-view-container': 'loading-view-container',
  'loading-view-content': 'loading-view-content',
  'loading-view-icon': 'loading-view-icon',
  'loading-view-meta': 'loading-view-meta',
  'loading-view-text': 'loading-view-text',
  'menu': 'menu',
  'menu-block': 'menu-block',
  'menu-bottom': 'menu-bottom',
  'menu-brand': 'menu-brand',
  'menu-brand-container': 'menu-brand-container',
  'menu-brand-image': 'menu-brand-image',
  'menu-button': 'menu-button',
  'menu-container': 'menu-container',
  'menu-sticky': 'menu-sticky',
  'menu-top': 'menu-top',
  'new-chat': 'new-chat',
  'new-chat-form': 'new-chat-form',
  'new-chat-heading': 'new-chat-heading',
  'new-chat-input': 'new-chat-input',
  'new-chat-input-container': 'new-chat-input-container',
  'new-chat-loading': 'new-chat-loading',
  'new-chat-loading-icon': 'new-chat-loading-icon',
  'new-chat-suggestions': 'new-chat-suggestions',
  'new-delivery-page': 'new-delivery-page',
  'new-delivery-view': 'new-delivery-view',
  'new-delivery-view-content': 'new-delivery-view-content',
  'new-delivery-view-filler': 'new-delivery-view-filler',
  'new-delivery-view-footer': 'new-delivery-view-footer',
  'new-delivery-view-form': 'new-delivery-view-form',
  'new-delivery-view-header': 'new-delivery-view-header',
  'new-delivery-view-header-icon': 'new-delivery-view-header-icon',
  'new-delivery-view-loading': 'new-delivery-view-loading',
  'new-delivery-view-loading-spinner': 'new-delivery-view-loading-spinner',
  'new-delivery-view-title': 'new-delivery-view-title',
  'no-scrollpop': 'no-scrollpop',
  'node-bg': 'node-bg',
  'node-bg-node': 'node-bg-node',
  'parallax': 'parallax',
  'pending': 'pending',
  'profile-page': 'profile-page',
  'profile-view': 'profile-view',
  'profile-view-content': 'profile-view-content',
  'profile-view-filler': 'profile-view-filler',
  'profile-view-footer': 'profile-view-footer',
  'profile-view-header': 'profile-view-header',
  'profile-view-header-icon': 'profile-view-header-icon',
  'profile-view-info': 'profile-view-info',
  'profile-view-info-item': 'profile-view-info-item',
  'profile-view-loading': 'profile-view-loading',
  'profile-view-loading-spinner': 'profile-view-loading-spinner',
  'report-page': 'report-page',
  'report-view': 'report-view',
  'report-view-content': 'report-view-content',
  'report-view-header': 'report-view-header',
  'report-view-header-icon': 'report-view-header-icon',
  'report-view-loading': 'report-view-loading',
  'report-view-loading-icon': 'report-view-loading-icon',
  'report-view-pagination': 'report-view-pagination',
  'scrollpop': 'scrollpop',
  'search-bar': 'search-bar',
  'search-bar-input': 'search-bar-input',
  'sidebar': 'sidebar',
  'sidebar-button': 'sidebar-button',
  'sidebar-container': 'sidebar-container',
  'sidebar-content': 'sidebar-content',
  'sidebar-header': 'sidebar-header',
  'sidebar-header-logo': 'sidebar-header-logo',
  'sidebar-heading': 'sidebar-heading',
  'sidebar-loading-icon': 'sidebar-loading-icon',
  'sidebar-recent-empty': 'sidebar-recent-empty',
  'sidebar-recent-heading': 'sidebar-recent-heading',
  'sidebar-recent-list': 'sidebar-recent-list',
  'suggestion-button': 'suggestion-button',
  'suggestion-button-content': 'suggestion-button-content',
  'suggestion-button-continue-icon': 'suggestion-button-continue-icon',
  'suggestion-button-filler': 'suggestion-button-filler',
  'suggestion-button-icon': 'suggestion-button-icon',
  'table': 'table',
  'text': 'text',
  'theme-bubble': 'theme-bubble'
} as const;

export type ClassName = (keyof typeof classNames);
export type PossibleClassName = ClassName | false | null | undefined;
export function useClasses(...args: PossibleClassName[]): string {
  const validClass = (arg: PossibleClassName) => !!(arg && arg in classNames);
  const validClasses = args.filter(validClass) as ClassName[];

  return validClasses.map(arg => classNames[arg]).join(' ');
}

